import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import OxyAISection from './components/OxyAISection';
import EducationSection from './components/EducationSection';
import SupplementationSection from './components/SupplementationSection';
import FundraisingSection from './components/FundraisingSection';
import ImpactSection from './components/ImpactSection';
import FinalCTASection from './components/FinalCTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'NGO',
      '@id': `${siteUrl}/#organization`,
      name: 'Diatomic Life Foundation',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: `${siteUrl}/vite.svg`,
        width: 512,
        height: 512,
      },
      description:
        'Diatomic Life Foundation prevents and reverses oxygen deficiency through education, AI-powered screening, and affordable oxygen supplementation for families in need.',
      foundingDate: '2020',
      areaServed: {
        '@type': 'Country',
        name: 'India',
      },
      knowsAbout: ['Oxygen Deficiency', 'Oxygen Supplementation', 'AI Health Screening', 'Public Health Education'],
      sameAs: [],
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        availableLanguage: 'English',
      },
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'Diatomic Life Foundation',
      publisher: { '@id': `${siteUrl}/#organization` },
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/?s={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Diatomic Life Foundation | Oxygen for All – Donate, Screen & Educate',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      description:
        'Diatomic Life Foundation fights oxygen deficiency through AI screening, education, and supplementation. Donate today to help families access life-saving oxygen support.',
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        ],
      },
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <SEO
        title="Diatomic Life Foundation | Oxygen for All – Donate, Screen & Educate"
        description="Diatomic Life Foundation fights oxygen deficiency through AI screening, education, and supplementation. Donate today to help families access life-saving oxygen support."
        keywords="oxygen deficiency, donate oxygen, Diatomic Life Foundation, OxyAI, oxygen supplementation"
        canonical={`${siteUrl}/`}
        ogImage={`${siteUrl}/og-home.jpg`}
        schemaJson={schema}
      />
      <Header />
      <main>
        <HeroSection />
        <MissionSection />
        <OxyAISection />
        <EducationSection />
        <SupplementationSection />
        <FundraisingSection />
        <ImpactSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
